import { NodeDynamicSuffix } from "../../constants/node";

interface GetNodeDynamicDataParams {
  nodeId?: string;
  data?: Record<string, unknown>;
  suffix?: NodeDynamicSuffix;
}

export function getNodeDynamicData<T>({
  nodeId,
  data,
  suffix,
}: GetNodeDynamicDataParams): T | null | undefined {
  if (!nodeId || !data) return undefined;

  const key = suffix ? `${nodeId}_${suffix}` : nodeId;
  return data[key] as T | null | undefined;
}
